require('./cities-new-container.scss')

module.exports = {
  template: require('./cities-new-container.pug')()
  controller: require('./cities-new-container.ctrl')
  bindings:
    country: '<'
}
